import type { AxiosInstance } from 'axios'

import axios from 'axios'

export default defineNuxtPlugin(() => {
  const config = useRuntimeConfig().public

  const api: AxiosInstance = axios.create({
    baseURL: config.appUrl,
    withCredentials: false,
    timeout: 60000,
  })

  if (config.hiringApiToken) {
    api.defaults.headers.common.Authorization = `Bearer ${config.hiringApiToken}`
  }

  return {
    provide: { axios: api },
  }
})
